export const colors = {
  buttons: {
    primary: '#2B76C2',
    primaryHover: '#115BA6',
    secondary: '#2A5580',
    secondaryHover: '#19456E',
    dark: '#115BA6',
    darkHover: '#115BA6',
    light: '#1D4D7F',
    text: '#D6F2FF',
  },
  text: {
    dark: '#D6F2FF',
    accent: '#95CDFF',
    light: '#D6F2FF',
    active: '#2B76C2',
  },
  background: {
    light: '#1B1D1F',
    dark: '#141517',
    accent: '#143556',
    medium: '#173D63',
    transparent: '#1C4773B2',
    tooltip: '#18538F',
  },
  elements: {
    primary: '#1C4D7E',
    primaryHover: '#225B94',
    dark: '#0F4984',
    skeletonPrimary: '#204E7D',
    skeletonSecondary: '#2B65A0',
    accent: '#1E76CE',
  },
  border: {
    primary: '#113C67',
  },
  gradient: {
    fade: 'linear-gradient(90deg, #1B446F 40.38%, rgba(27, 68, 111, 0) 100%)',
  },
  accent: {
    success: '#387545',
    error: '#E5373A',
    soft: '#FFEBC3',
  },
  tags: {
    processing: '#88D5ED',
    success: '#BFE1A8',
    reject: '#FFA089',
    text: '#3E3E3E',
  },
};
